import styled from 'styled-components';

export const TickerCell = styled.div`
  cursor: pointer;
  width: 100px;
  display: flex;
  gap: 8px;
  text-align: right;
`;

export const Ticker = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const AssetName = styled.p`
  width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Name = styled.p`
  padding: 8px;
`;
